<template>
  <div ref="menu" class="dropdown" :class="{ 'is-active': expanded, 'is-right': !isMobile }">
    <div class="dropdown-trigger">
      <button class="button" aria-haspopup="true" aria-controls="dropdown-menu" @click="toggle">
        <span class="icon">
          <i class="far fa-calendar-days"></i>
        </span>
        <span class="icon is-small">
          <i class="fas fa-angle-down" aria-hidden="true"></i>
        </span>
      </button>
    </div>
    <div id="dropdown-menu" class="dropdown-menu" role="menu">
      <div class="dropdown-content">
        <a href="" class="dropdown-item" @click.prevent="select(today, null)"> Today </a>
        <a href="" class="dropdown-item" @click.prevent="select(addDays(today, -7), null)">
          Last 7 Days
        </a>
        <a href="" class="dropdown-item" @click.prevent="select(addDays(today, -30), null)">
          Last 30 Days
        </a>
        <a href="" class="dropdown-item" @click.prevent="select(startOfYear(today), null)">
          All of {{ year }}
        </a>
        <hr class="dropdown-divider" />
        <a href="" class="dropdown-item" @click.prevent="select(null, null)">Clear Date Filter</a>
      </div>
    </div>
  </div>
</template>

<script setup>import { ref as _ref, computed as _computed } from 'vue';

  import { onClickOutside, useEventListener } from "@vueuse/core";
  import { format, addDays, startOfYear } from "date-fns";
  import { nextTick } from "vue";

  const emit = defineEmits(["update:model-value"]);

  let isMobile = _ref(false);
  useEventListener(document, "breakpoint:change", ({ name, matches }) => {
    if (name == "mobile") {
      isMobile.value = matches;
    }
  });

  const menu = _ref(null);
  let expanded = _ref(false);

  onClickOutside((menu), () => {
    expanded.value = false;
  });

  const toggle = () => {
    expanded.value = !expanded.value;
  };

  const year = _computed(() => {
    return format(new Date(), "yyyy");
  });

  const today = _computed(() => new Date());

  const formatDate = (d) => format(d, "yyyy-MM-dd");

  const select = (begin, end) => {
    expanded.value = false;

    const emitMessage = () => {
      emit("update:model-value", {
        begin: begin ? formatDate(begin) : null,
        end: end ? formatDate(end) : null,
      });
    };

    /* workaround for <input type=date>.value presenting as "" value when invalid.
     * This forces a re-render. */
    if (begin === null && end === null) {
      emit("update:model-value", { begin: "1970-01-01", end: "1970-01-01" });
      nextTick(() => emitMessage());
    } else {
      emitMessage();
    }
  };
</script>
